import { ChangeDetectionStrategy, Component } from '@angular/core';
import { SectionHeaderComponent } from '@app/widgets';
import { TuiIcon } from '@taiga-ui/core';

@Component({
  selector: 'app-native-builds-ios-section',
  imports: [SectionHeaderComponent, TuiIcon],
  templateUrl: './native-builds-ios-section.component.html',
  styleUrl: './native-builds-ios-section.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NativeBuildsIosSectionComponent {
  protected readonly iosFeatures = [
    {
      icon: '@tui.layers',
      title: 'Build Schemes',
      description:
        'Support for multiple build schemes to organize and manage different build targets and environments.',
    },
    {
      icon: '@tui.settings',
      title: 'Build Configurations',
      description:
        'Flexible build configurations for debug, release, and custom setups with specific compiler settings.',
    },
    {
      icon: '@tui.code',
      title: 'Bitcode Support',
      description:
        'Built-in bitcode generation for optimized app performance and future iOS platform compatibility.',
    },
  ];
}
